import React, { useRef } from 'react';

import BobModal from '../../../components/BobModal';
import WatchDogReport from '../../../components/WatchDogReport';
import { savePDF } from '@progress/kendo-react-pdf';

const PreviewWatchDogReportModal = ({
    close,
    open,
    currentReport,
    targetReport,
    ...props
}) => {
    const pdf = useRef();

    const reportPageTemplate = props => {
        return (
            <div
                style={{
                    position:  'absolute',
                    bottom:    '20px',
                    display:   'inline-block',
                    fontSize:  '12px',
                    borderTop: '1px solid gray',
                    margin:    '1rem 5rem 4rem 5rem',
                    width:     '88%'
                }}
            >
                <span style={{ fontSize: '12px', color: 'gray', padding: '1rem 0 0 0 ', float: 'left'}}>
                    This report was generated by BOB from KEY2ACT
                </span>
                <span style={{ fontSize: '12px', color: 'gray', padding: '1rem 0 0 0 ', float: 'right'}}>
                    {props.pageNum} / {props.totalPages}
                </span>
            </div>
        );
    };

    const handleDownload = () => {
        let report = pdf.current;

        savePDF(report, {
            paperSize:      'Letter',
            scale:          0.7,
            margin:         {top: 30, left: 0, right: 60, bottom: 100},
            forcePageBreak: '.page-break',
            fileName:       `${targetReport.SiteName}_WatchDogReport`,
            pageTemplate:   reportPageTemplate
        }, () => {
            close();
        });
    };

    const handleClose = () => {
        close();
    };

    return (
        <BobModal
            onCancel={handleClose}
            onClose={handleClose}
            rootClass={'reporting-modal'}
            open={open}
            cancelText={'Close'}
            confirmText={'Download'}
            onConfirm={handleDownload}
            applyHidden={false}
            isRemoveFooter={false}
            title={'Preview Watchdog Report'}
        >
            <WatchDogReport report={targetReport} ref={pdf} />
        </BobModal>
    );
};

export default PreviewWatchDogReportModal;
